import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SalesPage } from './sales.page';
import { AuthGuard } from '../services/user/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: SalesPage
  },
  {
    path: 'sale-receipt/:id',
    loadChildren: () => import('./sale-receipt/sale-receipt.module').then( m => m.SaleReceiptPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'sale-checkout',
    loadChildren: () => import('./sale-checkout/sale-checkout.module').then( m => m.SaleCheckoutPageModule),
    canActivate: [AuthGuard]

  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SalesPageRoutingModule {}
